import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Text from '../../Text';
import { UserSettings } from './style';
import { SAVE_PRINT_SETTINGS } from '../../../../app/redux/actions/statistics';
import { EXPORT_TABS } from '.';
import TimeIntervalFilter from '../../TimeIntervalFilter';

const CategoriesTab = ({ savePrintSettings }) => {
  return (
    <>
      <Text type="h2" mb={8}>
        Aree tematiche
      </Text>
      <Text type="b3" mb={24}>
        Da questa sezione puoi scaricare la lista di aree tematiche presenti
        sulla piattaforma.
      </Text>
      <UserSettings>
        <div className="user-settings">
          <Text type="h3" mb={8}>
            Impostazioni
          </Text>
          <Text type="b3" mb={32}>
            Per procedere con l’export, seleziona i filtri in base alle tue
            esigenze.
          </Text>
          <div style={{ width: '200px' }}>
            <Text type="h3" mb={16} className="mandatory">
              Periodo
            </Text>
            <TimeIntervalFilter
              id="filter-time-interval-modal-users-tab"
              forceSplitMonths
              callback={(start_date, end_date) => {
                savePrintSettings({
                  key: 'start_date',
                  value: start_date,
                });
                savePrintSettings({
                  key: 'end_date',
                  value: end_date,
                });
              }}
              maxMonthsDiff={6}
            />
          </div>
        </div>
      </UserSettings>
    </>
  );
};

CategoriesTab.propTypes = {
  savePrintSettings: PropTypes.func,
};

export default connect(
  (state) => ({}),
  (dispatch) => ({
    savePrintSettings: ({ key, value }) =>
      dispatch({
        type: SAVE_PRINT_SETTINGS,
        key,
        value,
        tab: EXPORT_TABS.CATEGORIES,
      }),
  })
)(CategoriesTab);
